import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, isEqual } from 'lodash';

import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';
import FilterRangeService from 'inventory-listing/components/ListingFilters/Components/FilterRange/FilterRangeService/FilterRangeService.js';
import ListingFiltersYearsRange from 'inventory-listing/components/ListingFilters/Components/ListingFiltersYears/ListingFiltersYearsRange/ListingFiltersYearsRange.jsx';
import ListingFiltersYearsButtons from 'inventory-listing/components/ListingFilters/Components/ListingFiltersYears/ListingFiltersYearsButtons/ListingFiltersYearsButtons.jsx';

class ListingFiltersYears extends React.Component {
    shouldComponentUpdate(nextProps) {
        const propsExtremeValues = FilterRangeService.getExtremeValues(this.props.years);
        const nextPropsExtremeValues = FilterRangeService.getExtremeValues(nextProps.years);
        return !isEqual(propsExtremeValues, nextPropsExtremeValues) || isEmpty(nextProps.yearRange);
    }

    render() {
        const extremeValues = FilterRangeService.getExtremeValues(this.props.years);
        const { extremeMin, extremeMax } = extremeValues;
        const yearRange = extremeMax - extremeMin;

        if (yearRange <= 0) {
            return null;
        }

        if (yearRange === 1) {
            return (
                <ListingFiltersYearsButtons
                    years={this.props.years}
                    contextYear={this.props.contextYear}
                    updateVehicleCriteria={this.props.updateVehicleCriteria}
                />
            );
        }

        // by default yearRange > 1
        return (
            <ListingFiltersYearsRange
                years={this.props.years}
                yearRange={this.props.yearRange}
                contextYear={this.props.contextYear}
                updateVehicleCriteria={this.props.updateVehicleCriteria}
            />
        );
    }
}

ListingFiltersYears.defaultProps = {
    years: [],
    contextYear: undefined,
    yearRange: {},
};

ListingFiltersYears.propTypes = {
    years: PropTypes.arrayOf(PropTypes.instanceOf(MetaDataModel)),
    yearRange: PropTypes.object,
    contextYear: PropTypes.oneOf([PropTypes.number, PropTypes.undefined]),
    updateVehicleCriteria: PropTypes.func.isRequired,
};

ListingFiltersYears.displayName = 'ListingFiltersYears';

export default ListingFiltersYears;
